import axiosInstanceProvince from "../helper/axiosIntanceProvince";
import { normalizeStringInObject } from "../utils/normalize";

//tien
const provinces = (params) => {
    return axiosInstanceProvince.get('p/', normalizeStringInObject(params));
}

const districts = (params) => {
    return axiosInstanceProvince.get(`p/${params?.code}?depth=2`, normalizeStringInObject(params));
}

const wards = (params) => {
    return axiosInstanceProvince.get(`d/${params?.code}?depth=2`, normalizeStringInObject(params));
}

export default {
    provinces,
    districts,
    wards
}
